export const FORMANTS_WIDTH = 200;
export const FORMANTS_HEIGHT= 100;
